import React, { Component } from 'react'

export default class Abonnement extends Component {
  render() {
    return (
      <div>Abonnement</div>
    )
  }
}
